export default {
	apiUrl: 'https://admin-child-labour-risk-dashboard.iniciativa2025alc.org/',
	//apiUrl: 'http://backend-dashboard-ir-staging.us-east-1.elasticbeanstalk.com/',
	//apiUrl: 'http://localhost:4000/',
	debug: true,
};
